/*
 * Card data, generated from the original Dima Maghrib data.json.
 * Keyed by the URL id (the /c/<id> and /pages/carte/<id> segment).
 * `number` is the printed card number shown in the title (id 2 -> Carte n°266).
 * `clips[].path` is relative to the "Audio base URL" set on the Card section.
 */
window.CARD_AUDIO = {
  "2": {
    "number": "266",
    "clips": [
      {
        "label": "Douaâ/Istisqaâ",
        "path": "Douaâ/Istisqaâ.m4a"
      }
    ]
  },
  "3": {
    "number": "267",
    "clips": [
      {
        "label": "Douaâ/Tarawih",
        "path": "Douaâ/Tarawih.m4a"
      }
    ]
  },
  "4": {
    "number": "268",
    "clips": [
      {
        "label": "Douaâ/Janaza",
        "path": "Douaâ/Janaza.m4a"
      }
    ]
  },
  "5": {
    "number": "269",
    "clips": [
      {
        "label": "Douaâ/Aïd",
        "path": "Douaâ/Aïd.m4a"
      }
    ]
  },
  "6": {
    "number": "270",
    "clips": [
      {
        "label": "Coran/Sourate An Nas Récitation marocaine",
        "path": "Coran/Sourate An Nas Récitation marocaine.mp3"
      },
      {
        "label": "Coran/Sourate Al Falaq Récitation marocaine",
        "path": "Coran/Sourate Al Falaq Récitation marocaine.mp3"
      }
    ]
  },
  "7": {
    "number": "271",
    "clips": [
      {
        "label": "Coran/Sourate Al Ikhlass (Récitation marocaine)",
        "path": "Coran/Sourate Al Ikhlass (Récitation marocaine).mp3"
      },
      {
        "label": "Coran/Sourate Al Masad (Récitation marocaine)",
        "path": "Coran/Sourate Al Masad (Récitation marocaine).mp3"
      }
    ]
  },
  "8": {
    "number": "272",
    "clips": [
      {
        "label": "Coran/Sourate An Nasr (Récitation marocaine)",
        "path": "Coran/Sourate An Nasr (Récitation marocaine).mp3"
      },
      {
        "label": "Coran/Sourate Al Kafirune (Récitation marocaine)",
        "path": "Coran/Sourate Al Kafirune (Récitation marocaine).mp3"
      }
    ]
  },
  "9": {
    "number": "273",
    "clips": [
      {
        "label": "Coran/Sourate Al Asr (Récitation marocaine)",
        "path": "Coran/Sourate Al Asr (Récitation marocaine).mp3"
      },
      {
        "label": "Coran/Sourate Al Kawtar (Récitation marocaine)",
        "path": "Coran/Sourate Al Kawtar (Récitation marocaine).mp3"
      }
    ]
  },
  "10": {
    "number": "274",
    "clips": [
      {
        "label": "Coran/Sourate Al-Fatiha",
        "path": "Coran/Sourate Al-Fatiha.mp3"
      },
      {
        "label": "Coran/آية الكرسي - قراءة بالصيغة المغربية الأصيلة - حسن الفاضلي",
        "path": "Coran/آية الكرسي - قراءة بالصيغة المغربية الأصيلة - حسن الفاضلي.mp3"
      }
    ]
  },
  "11": {
    "number": "275",
    "clips": [
      {
        "label": "Proverbes/Shour",
        "path": "Proverbes/Shour.m4a"
      }
    ]
  },
  "12": {
    "number": "276",
    "clips": [
      {
        "label": "Proverbes/Li fat mat",
        "path": "Proverbes/Li fat mat.m4a"
      }
    ]
  },
  "13": {
    "number": "277",
    "clips": [
      {
        "label": "Proverbes/Une main n_applaudit pas",
        "path": "Proverbes/Une main n_applaudit pas.m4a"
      }
    ]
  },
  "14": {
    "number": "278",
    "clips": [
      {
        "label": "Proverbes/Le chameau ne voir pas sa 7deba",
        "path": "Proverbes/Le chameau ne voir pas sa 7deba.m4a"
      }
    ]
  },
  "15": {
    "number": "279",
    "clips": [
      {
        "label": "Proverbes/Lkhawa 7dha denya",
        "path": "Proverbes/Lkhawa 7dha denya.m4a"
      }
    ]
  },
  "16": {
    "number": "280",
    "clips": [
      {
        "label": "Mariage/Slat w slam",
        "path": "Mariage/Slat w slam.mp3"
      }
    ]
  },
  "17": {
    "number": "281",
    "clips": [
      {
        "label": "Mariage/Daha",
        "path": "Mariage/Daha.m4a"
      },
      {
        "label": "Mariage/Gatlik mok",
        "path": "Mariage/Gatlik mok.m4a"
      }
    ]
  },
  "18": {
    "number": "282",
    "clips": [
      {
        "label": "Mariage/Wa hya moulay soltane",
        "path": "Mariage/Wa hya moulay soltane.m4a"
      },
      {
        "label": "Mariage/Lalla La3roussa",
        "path": "Mariage/Lalla La3roussa.m4a"
      }
    ]
  },
  "19": {
    "number": "283",
    "clips": [
      {
        "label": "Foot/Chalalalala",
        "path": "Foot/Chalalalala.m4a"
      },
      {
        "label": "Foot/Li ma bougea machi maghribi",
        "path": "Foot/Li ma bougea machi maghribi.m4a"
      }
    ]
  },
  "20": {
    "number": "284",
    "clips": [
      {
        "label": "Patrimoine/Achta tatata",
        "path": "Patrimoine/Achta tatata.m4a"
      },
      {
        "label": "Patrimoine/Tikchbila",
        "path": "Patrimoine/Tikchbila.m4a"
      }
    ]
  },
  "21": {
    "number": "285",
    "clips": [
      {
        "label": "Foot/Allah ya rabbi Allah",
        "path": "Foot/Allah ya rabbi Allah.m4a"
      }
    ]
  }
};
